import React from 'react';

import Teaser from '../../../../components/Teaser';

import './style.scss';

const NodeProjectTeaser = ({ entity, large, labeled, lazyload }) => {

  const showDate = entity.getIn(['field_show_date', 0, 'value']);

  return (
    <div className="BaseTeaser NodeProjectTeaser">
      <Teaser entity={entity} large={large} labeled={labeled} type="project" showDate={showDate} lazyload={lazyload} />
    </div>
  );
};

export default NodeProjectTeaser;
